export default __webpack_public_path__ + "static/media/insertingBG.766e7670.jpg";